import { styled } from "@phntms/css-components";
import { SocialLinks } from "@itchannelplus/ui/components/SocialLinks";
import styles from "./styles.module.scss";

export const FooterContainer = styled("div", {
  css: styles.footerContainer,
});

export const Rainbow = styled("div", {
  css: styles.rainbow,
});


export const LinkSection = styled("div", {
  css: ["container", styles.linkSection],
});

export const Columns = styled("div", {
  css: styles.columns,
});

export const Column = styled("div", {
  css: styles.column,
});

export const ColumnTitle = styled("h4", {
  css: ["paragraph-txt", styles.columnTitle],
});

export const BottomSection = styled("div", {
  css: styles.bottomSection,
});

export const InfoContent = styled("div", {
  css: ["container", styles.infoContent],
});

export const InfoLabel = styled("p", {
  css: ["caption-txt", styles.infoLabel, "uppercase-txt"],
  variants: {
    hide: {
      "below-mobile": ["hide-below-mobile"],
      "over-mobile": ["hide-over-mobile"],
      "below-tablet": ["hide-below-tablet"],
      "over-tablet": ["hide-over-tablet"],
    },
  },
});

export const ContactLinks = styled("div", {
  css: [styles.contactLinks],
});

export const FormRow = styled("form", {
  css: [styles.formRow],
});

export const MobileLinks = styled(SocialLinks, {
  css: [styles.mobileLinks],
});
